/**
 * Custom Display Component for displaying a single Entry from a nested form
 */
import React from 'react';

import {Field, FieldProp} from '../../types';
import {fieldValue, fieldValueLabel} from '../../_helpers/form';
import {initialFormState} from '../Form';

type NestedFormEntryViewProps = FieldProp & {};

export const NestedFormEntryView: React.FunctionComponent<NestedFormEntryViewProps> = ({
                                                                                           field,
                                                                                           form,
                                                                                           formState,
                                                                                       }): JSX.Element => {
    // @ts-ignore
    const nestedFormFieldId: number | false = field?.flowCustomDisplayComponentConfig?.nestedFormFieldId ?
        // @ts-ignore
        field.flowCustomDisplayComponentConfig.nestedFormFieldId
        :
        false;

    // @ts-ignore
    const displayFormat: string = field?.flowCustomDisplayComponentConfig?.displayFormat ?
        // @ts-ignore
        field?.flowCustomDisplayComponentConfig?.displayFormat
        :
        '';

    // get NestedForm value from state
    const nestedFormField: Field | false = nestedFormFieldId !== false && form?.fieldMap.hasOwnProperty(nestedFormFieldId) ? form.fieldMap[nestedFormFieldId] : false;
    const nestedFormFieldValue: any = nestedFormField !== false && formState ? fieldValue(formState, nestedFormField) : [];
    const nestedFormState = {
        ...initialFormState,
        fieldValues: nestedFormFieldValue.length > 0 ? nestedFormFieldValue[nestedFormFieldValue.length - 1] : {}
    };

    // NOTE: hardcoding for specific use case, need to come back and make this configurable
    // @ts-ignore
    const revisionField = nestedFormField.nestedForm.fieldMap[1];
    // @ts-ignore
    const urlField = nestedFormField.nestedForm.fieldMap[2];
    const revision = fieldValue(nestedFormState, revisionField);
    const url = fieldValue(nestedFormState, urlField);
    const filename = fieldValueLabel(nestedFormState, urlField);

    return (
        <div>
            <a href={url}>{revision} - {filename}</a>
        </div>
    );
};
